import * as React from 'react';

const SvgBookmark = (props) => /* @__PURE__ */ React.createElement("svg", { "data-fabric-icon-v2": "mobile-sheet-24", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.6394 18.1049L12 17.6482L11.3606 18.1049L6.1 21.8625V3C6.1 2.50294 6.50294 2.1 7 2.1H17C17.4971 2.1 17.9 2.50294 17.9 3V21.8625L12.6394 18.1049Z", stroke: "currentColor", strokeWidth: 2.2 }));

export { SvgBookmark as default };
//# sourceMappingURL=bookmark.svg.js.map
